module.exports = __webpack_public_path__ + "static/img/5.d5bc838.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-cn/5.jpg
// module id = d5iY
// module chunks = 1